/**
 * Where a campaign stands, as a badge, in the words a creator needs.
 */

import { Badge } from "../components/ui.js";
import type { CampaignPhase } from "./campaigns.js";

const PHASES: Record<CampaignPhase, { label: string; tone: "green" | "amber" | "grey" | "blue" }> =
  {
    upcoming: { label: "Starting soon", tone: "blue" },
    running: { label: "Open", tone: "green" },
    ended: { label: "Results pending", tone: "amber" },
    settled: { label: "Settled", tone: "grey" },
    refunded: { label: "Refunded", tone: "grey" },
  };

export function PhaseBadge({ phase }: { phase: CampaignPhase }) {
  const { label, tone } = PHASES[phase];
  return <Badge tone={tone}>{label}</Badge>;
}
